module.exports = __webpack_public_path__ + "static/media/jkglfw.3f9bcba8.png";